import HeaderNavigateLogoSvg from "@/pages/root/static/header-navigate-logo.svg?react";
import { Link } from "react-router-dom";
import type { HeaderLogoProps } from "../types/index";
import { useHeaderLogoStyles } from "./header-logo.styles";

export const HeaderLogo = ({ href }: HeaderLogoProps) => {
  const { styles } = useHeaderLogoStyles();

  const logo = <HeaderNavigateLogoSvg className={styles.logoSVG} />;

  return (
    <div className={styles.logo}>
      {href ? (
        <Link to={href} aria-label="Go to home page">
          {logo}
        </Link>
      ) : (
        logo
      )}
    </div>
  );
};
